//@flow
import React, { useState } from 'react';
import classNames from 'classnames';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { CallToAction } from 'components/atoms/callToAction';
import { Image } from 'components/atoms/image';
import playButton from 'assets/images/Play-Button-S.png';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
// eslint-disable-next-line
import "./styles.scss";

type Props = {
  heading: string,
  subHeading: string,
  videoData?: string,
  imageData?: string,
  content: string,
  buttonName?: string,
  toggleButton?: boolean,
  isComponentLoaded?: boolean,
  videoThumbnailUrl?: string,
  containerClass?: string,
  variableMargin?: boolean,
  onClick?: () => void,
};

const VideoInfoModuleMobile = (props: Props) => {
  const { height } = useViewport();
  const {
    heading,
    subHeading,
    videoData,
    buttonName,
    imageData,
    content,
    onClick,
    videoThumbnailUrl,
    containerClass,
    variableMargin = true,
    variablePadding,
  } = props;

  const [showVideoLayout, setshowVideoLayout] = useState(false);

  const containerClassNames = classNames(
    variablePadding
      ? 'video-info-module-mobile no-top-padding'
      : 'video-info-module-mobile',
    containerClass
  );

  const showOverlay = showVideoLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={videoData}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'testimonialVideoOverlay'}
        onClosePress={() => setshowVideoLayout(false)}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={containerClassNames} style={{ height }}>
      <div className={'inner-section-mobile'}>
        <Row style={{ height: '135px' }}>
          <Col xs={{ span: 7 }}>
            <h2 className={'heading-video-module'}>{heading}</h2>
          </Col>
          <Col
            xs={{ span: 11 }}
            style={
              variableMargin ? { marginTop: '-40px' } : { marginTop: '-20px' }
            }
          >
            <HTMLView
              tagName={'h3'}
              html={subHeading}
              className={'sub-heading'}
            />
          </Col>
        </Row>
        <Row className={'media-row'}>
          <Col className={'media-col'}>
            {videoData && (
              <>
                <img src={videoThumbnailUrl} alt="video" />
                <img
                  className={'play-icon'}
                  src={playButton}
                  alt={'play-icon'}
                  onClick={() => setshowVideoLayout(true)}
                />
              </>
            )}
            {imageData && (
              <div className={'image-data'}>
                <Image src={imageData} alt={'module-image'} />
              </div>
            )}
          </Col>
        </Row>
        {showOverlay}
        <Row style={{ height: '100px' }}>
          <Col xs={{ span: 12 }}>
            <HTMLView tagName={'p'} html={content} className={'content'} />
          </Col>
          {buttonName && (
            <div className={'explore'}>
              <CallToAction
                text={buttonName}
                mode={'transparent'}
                type={'link'}
                onClick={onClick}
                size={'small'}
                isMobile={'true'}
              />
            </div>
          )}
        </Row>
      </div>
    </div>
  );
};

export default VideoInfoModuleMobile;
